export enum LaboratoryProfileEnum {
  LABORATORY_PROFILE_SECTION_STRUCTURE = 'section-structure--laboratory-profile',
  LABORATORY_PROFILE_SECTION_ADDRESS = 'section-address--laboratory-profile',
  LABORATORY_PROFILE_SECTION_RATING = 'section-rating--laboratory-profile',
  LABORATORY_PROFILE_SECTION_SIMILAR_LABORATORIES = 'section-similar-laboratories--laboratory-profile',
  LABORATORY_PROFILE_GALLERY_IMAGE = 'gallery-image--gallery-component',
}
